import { render, staticRenderFns } from "./AutobuyerInput.vue?vue&type=template&id=4d836647&scoped=true&"
import script from "./AutobuyerInput.vue?vue&type=script&lang=js&"
export * from "./AutobuyerInput.vue?vue&type=script&lang=js&"
import style0 from "./AutobuyerInput.vue?vue&type=style&index=0&id=4d836647&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d836647",
  null
  
)

export default component.exports